<template>
  <div class="passwordetail">
    <navBack :title="certName"></navBack>
    <div class="passwordetail_title">
      <p>{{ certName }}</p>
    </div>
    <div ref="certParent" style="padding: 20px; overflow: scroll">
      <iframe
        ref="certIframe"
        :src="certUrl"
        width="1400px"
        height="700px"
        frameborder="0"
        @load="scrollIframeToCenter"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import navBack from "../../components/navBack.vue";
export default {
  components: {
    navBack,
  },
  data() {
    return {
      certUrl: "",
      certName: "",
    };
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    userInfo: (state) => state.user.userInfo,
  }),

  watch: {
    "$route.query": {
      handler() {
        let newConfig = JSON.parse(localStorage.dynamicConfig);
        const item = this.$route.query;
        this.certName = item.type;
        if (newConfig.cert_url) {
          this.certUrl =
            newConfig.cert_url +
            "?name=" +
            window.btoa(unescape(encodeURIComponent(item.name))) +
            "&phone=" +
            item.phone +
            "&type=" +
            item.type +
            "&t=" +
            new Date().getTime();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    // iframe加载完成滚动到中间
    scrollIframeToCenter() {
      const iframe = this.$refs.certIframe;
      if (!iframe) return;

      // 内部文档总宽高
      const docWidth = iframe.scrollWidth;
      // 计算中间坐标
      const centerX = docWidth / 2 - this.$refs.certParent.offsetWidth / 2;

      // 滚动到中间
      this.$nextTick(() => {
        this.$refs.certParent.scrollLeft = centerX;
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .passwordetail_title {
    display: none;
  }
  .passwordetail {
    min-height: 700px;
    padding-bottom: 60px;
    background-color: #fff;
  }
}

@media screen and (min-width: 750px) {
  .passwordetail_title {
    height: 60px;
    font-weight: 500;
    font-size: 22px;
    line-height: 60px;
    padding-left: 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .passwordetail {
    min-height: 650px;
    padding-bottom: 20px;
    background-color: #fff;
  }
}
</style>
